import React, { useContext, useState } from 'react'
import styled from '@emotion/styled'
import StoreContext from '~/context/StoreContext'
import Button from '../Button'
import { navigate } from 'gatsby'
import { GetPrice } from '../../utils/helpers'
import { breakpoints } from '../../utils/styles'

import { getButtonBackground, getButtonColor } from '~/utils/helpers'

const QuickAdd = props => {
  const {
    variants,
    maxWidth = '100%',
    justifyContent = 'center',
    isWholesale = false,
    _setVariant,
    selectedVariant = variants[0],
    tags = [],
    handle = '',
    showInline = false,
  } = props
  const { addVariantToCart } = useContext(StoreContext)

  // Remove monthly subscriptions from main variant list
  const _variants = variants.filter(variant => {
    return variant.title.indexOf('Subscription') < 0
  })

  const _subscriptionVariants = variants.filter(variant => {
    return (
      variant.title.indexOf('Subscription') > 0 &&
      variant.title.indexOf('Hidden') === -1
    )
  })

  const [variant, setVariant] = useState({ ...selectedVariant })
  const [loading, setLoading] = useState(false)
  const [added, setAdded] = useState(false)

  const handleAddToCart = () => {
    setLoading(true)

    addVariantToCart(variant.shopifyId, 1, callback => {
      setLoading(false)
      setAdded(true)
    })
  }

  const cta = tags.includes('subscription') ? 'Subscribe' : 'Add to cart'
  const buttonBackground = getButtonBackground(handle)
  const buttonColor = getButtonColor(handle)
  return (
    <Wrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: justifyContent,
          flexWrap: showInline ? 'wrap' : 'nowrap',
          marginTop: 15,
          marginBottom: 20,
        }}
      >
        {_variants.map(v => {
          const isSelected = v.shopifyId === variant.shopifyId
          return (
            <div key={v.id} style={{ width: showInline ? '100%' : 'auto' }}>
              <Toggle
                onClick={e => {
                  e.preventDefault()
                  setVariant({ ...v })
                  if (_setVariant) _setVariant({ ...v })
                }}
                data-shopifyId={v.shopifyId}
                style={{
                  borderBottom: isSelected
                    ? '3px solid #215041'
                    : '3px solid transparent',
                  marginBottom: showInline ? 5 : 0,
                }}
              >
                {v.title}
              </Toggle>
            </div>
          )
        })}
      </div>
      {_subscriptionVariants.length > 0 && (
        <div style={{ margin: '-10px 0 20px 0' }}>
          {_subscriptionVariants.map(v => {
            const isSelected = v.shopifyId === variant.shopifyId
            // const _title = v.title.split(' / ')[1]
            // const _subscription = v.title.split(' / ')[0]
            return (
              <div key={v.id} style={{ position: 'relative' }}>
                <Toggle
                  onClick={e => {
                    e.preventDefault()
                    setVariant({ ...v })
                    if (_setVariant) _setVariant({ ...v })
                  }}
                  style={{
                    borderBottom: isSelected
                      ? '3px solid #215041'
                      : '3px solid transparent',
                  }}
                >
                  {v.title}
                </Toggle>
                <Save>Save 15%</Save>
              </div>
            )
          })}
        </div>
      )}
      <div style={{ maxWidth: maxWidth }}>
        {variant.availableForSale ? (
          <Button
            onClick={handleAddToCart}
            background={buttonBackground}
            color={buttonColor}
            style={{ maxWidth: 360 }}
          >
            {loading ? (
              'Adding...'
            ) : (
              <span>
                {cta} – {GetPrice(variant.price)}
                {isWholesale ? ' – Box 15' : ''}
              </span>
            )}
          </Button>
        ) : (
          <Disabled style={{ maxWidth: 360 }}>Out of stock</Disabled>
        )}

        {added && (
          <ViewCart
            style={{ maxWidth: 360 }}
            onClick={e => {
              navigate('/cart')
            }}
          >
            View cart &rarr;
          </ViewCart>
        )}
      </div>
    </Wrapper>
  )
}

export default QuickAdd

const ViewCart = styled(Button)`
  color: #215041;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  background: none;
  margin-top: 10px;
  line-height: 38px;
`

const Disabled = styled(Button)`
  color: #215041;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  background: none;
  line-height: 38px;
`

const Wrapper = styled.div`
  font-family: 'SohneBreit';
  letter-spacing: 1px;
  font-weight: 400;
`

const Save = styled.div`
  border-radius: 15px;
  height: 20px;
  display: none;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 1px;
  font-size: 10px;
  background: red;
  padding: 0 10px;
  color: white;
  top: 0;
  right: 0;
`

const Toggle = styled.button`
  cursor: pointer;
  margin-right: 20px;
  background: none;
  appearance: none;
  padding: 0;
  padding-bottom: 5px;
  outline: none;
  border-left: none;
  border-right: none;
  color: #215041;
  font-family: 'SohneBreit';
  border-top: none;
  letter-spacing: 1px;
  position: relative;
  font-size: 16px;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
  }
`
